// extracted by mini-css-extract-plugin
module.exports = {"rateCard":"RateCard_rateCard__1rNGL","rateDetailItemList":"RateCard_rateDetailItemList__5KqBv"};